import { render } from "./DescargaProducto.vue?vue&type=template&id=2d97f120"
import script from "./DescargaProducto.vue?vue&type=script&lang=js"
export * from "./DescargaProducto.vue?vue&type=script&lang=js"
script.render = render

export default script